import React from 'react';
import { IconProps } from './types';

export const Hamburger = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect y="5" width="26.087" height="2" rx="1" fill="black" />
    <rect y="11.7037" width="26.087" height="2" rx="1" fill="black" />
    <rect y="18.4074" width="26.087" height="2" rx="1" fill="black" />
  </svg>
);
